import { Routes } from '@angular/router';
import { authgaurdGuard as AuthGuard } from './core/gaurd/authgaurd.guard';
import { adminAuthGuard } from './core/gaurd/admin-auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./Shared/Components/layout/layout.component').then(m => m.LayoutComponent),
    children: [
      {
        path: '',
        loadComponent: () => import('./Clients/dashboard/dashboard.component').then(m => m.DashboardComponent),
        children: [
          {
            path: '',
            redirectTo: '/flight',
            pathMatch: 'full'
          },
          {
            path: 'flight',
            loadComponent: () => import('../app/Clients/Flight/flight-request/flight-request.component').then(m => m.FlightRequestComponent)
          },
        ]
      },
      {
        path: 'dubai-visa',
        loadComponent: () => import('./Clients/Visa/dubai-visa/dubai-visa.component').then(m => m.DubaiVisaComponent)
      },
      {
        path: 'visa-change',
        loadComponent: () => import('./Clients/Visa/visa-change/visa-change.component').then(m => m.VisaChangeComponent)
      },
      {
        path: 'visa/apply/:packageId',
        loadComponent: () => import('./Clients/Visa/visa-application/visa-application.component').then(m => m.VisaApplicationComponent)
      },
      {
        path: 'visa/track',
        loadComponent: () => import('./Clients/Visa/visa-track/visa-track.component').then(m => m.VisaTrackComponent)
      },
    ]
  },

  {
    path: '',
    loadComponent: () => import('./Shared/Components/inner-layout/inner-layout.component').then(m => m.InnerLayoutComponent),
    children: [
      {
        path: 'flight-response',
        loadComponent: () => import('../app/Clients/Flight/flight-response/flight-response.component').then(m => m.FlightResponseComponent)
      },
      {
        path: 'flight-fare-details',
        loadComponent: () => import('../app/Clients/Flight/flight-fare-details/flight-fare-details.component').then(m => m.FlightFareDetailsComponent)
      },
      {
        path: 'flight/reservation',
        loadComponent: () => import('../app/Clients/reservation/reservation.component').then(m => m.ReservationComponent)
      },
      {
        path: 'flight/confirmation',
        loadComponent: () => import('../app/Clients/Flight/confirmation/confirmation.component').then(m => m.ConfirmationComponent)
      },
      {
        path: 'flight/payment-failed',
        loadComponent: () => import('../app/Clients/Flight/payment-failed/payment-failed.component').then(m => m.PaymentFailedComponent)
      },
      {
        path: 'checkout-terms',
        loadComponent: () => import('../app/Clients/Static-Pages/checkout-terms/checkout-terms.component').then(m => m.CheckoutTermsComponent)
      },
      {
        path: 'sign-in',
        loadComponent: () => import('../app/Clients/Authantication/user-login/user-login.component').then(m => m.UserLoginComponent)
      },
      {
        path: 'sign-up',
        loadComponent: () => import('../app/Clients/Authantication/user-registration/user-registration.component').then(m => m.UserRegistrationComponent)
      },
      {
        path: 'forget-password',
        loadComponent: () => import('../app/Clients/Authantication/forget-password/forget-password.component').then(m => m.ForgetPasswordComponent)
      },
      {
        path: 'updatepassword',
        loadComponent: () => import('../app/Clients/Authantication/reset-password/reset-password.component').then(m => m.ResetPasswordComponent)
      },
    ]
  },
  {
    path: '',
    loadComponent: () => import('./Shared/Components/inner-layout/inner-layout.component').then(m => m.InnerLayoutComponent),
    children: [
      {
        path: 'about-us',
        loadComponent: () => import('../app/Clients/Static-Pages/about-us/about-us.component').then(m => m.AboutUsComponent)
      },
      {
        path: 'faqs',
        loadComponent: () => import('../app/Clients/Static-Pages/faqs/faqs.component').then(m => m.FaqsComponent)
      },
      {
        path: 'contact-us',
        loadComponent: () => import('../app/Clients/Static-Pages/contact-us/contact-us.component').then(m => m.ContactUsComponent)
      },
      {
        path: 'privacy-policy',
        loadComponent: () => import('../app/Clients/Static-Pages/privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent)
      },
      {
        path: 'terms-and-conditions',
        loadComponent: () => import('../app/Clients/Static-Pages/terms/terms.component').then(m => m.TermsComponent)
      },
      {
        path: 'page/:slug',
        loadComponent: () => import('../app/Clients/Static-Pages/dynamic-page/dynamic-page.component').then(m => m.DynamicPageComponent)
      },
      {
        path: 'user/reservation-details/:bookingRefNo/:reservationId/:emailId',
        loadComponent: () => import('../app/Clients/User-Dashboard/user-booking/user-booking-details/user-booking-details.component').then(m => m.UserBookingDetailsComponent)
      },
    ]
  },
  {
    path: '',
    loadComponent: () => import('./Shared/Components/user-login-layout/user-login-layout.component').then(m => m.UserLoginLayoutComponent),
    canActivate: [AuthGuard],
    children: [
      {
        path: 'user/dashboard',
        loadComponent: () => import('../app/Clients/User-Dashboard/login-dashboard/login-dashboard.component').then(m => m.LoginDashboardComponent)
      },
      {
        path: 'user/profile',
        loadComponent: () => import('../app/Clients/User-Dashboard/user-profile/user-profile.component').then(m => m.UserProfileComponent)
      },
      {
        path: 'user/booking',
        loadComponent: () => import('../app/Clients/User-Dashboard/user-booking/user-booking.component').then(m => m.UserBookingComponent)
      },
      {
        path: 'user/booking-details/:bookingRefNo/:reservationId',
        loadComponent: () => import('../app/Clients/User-Dashboard/user-booking/user-booking-details/user-booking-details.component').then(m => m.UserBookingDetailsComponent)
      },
      {
        path: 'user/settings',
        loadComponent: () => import('../app/Clients/User-Dashboard/user-settings/user-settings.component').then(m => m.UserSettingsComponent)
      },
      {
        path: 'user/visas',
        loadComponent: () => import('../app/Clients/User-Dashboard/user-visa-applications/user-visa-applications.component').then(m => m.UserVisaApplicationsComponent)
      },
    ]
  },
  {
    path: 'admin/login',
    loadComponent: () => import('./Clients/Admin/admin-login/admin-login.component').then(m => m.AdminLoginComponent)
  },
  {
    path: 'admin',
    canActivate: [adminAuthGuard],
    loadComponent: () => import('./Clients/Admin/admin-layout/admin-layout.component').then(m => m.AdminLayoutComponent),
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadComponent: () => import('./Clients/Admin/admin-dashboard-overview/admin-dashboard-overview.component').then(m => m.AdminDashboardOverviewComponent)
      },
      {
        path: 'content-editor',
        loadComponent: () => import('./Clients/Admin/admin-content-editor/admin-content-editor.component').then(m => m.AdminContentEditorComponent)
      },
      {
        path: 'package-manager',
        loadComponent: () => import('./Clients/Admin/admin-package-manager/admin-package-manager.component').then(m => m.AdminPackageManagerComponent)
      },
      {
        path: 'applications',
        loadComponent: () => import('./Clients/Admin/admin-applications-manager/admin-applications-manager.component').then(m => m.AdminApplicationsManagerComponent)
      },
      {
        path: 'profile-settings',
        loadComponent: () => import('./Clients/Admin/admin-profile-settings/admin-profile-settings.component').then(m => m.AdminProfileSettingsComponent)
      }
    ]
  },
  {
    path: '',
    loadComponent: () => import('./Shared/Components/inner-layout/inner-layout.component').then(m => m.InnerLayoutComponent),
    children: [
      {
        path: ':slug',
        loadComponent: () => import('../app/Clients/Static-Pages/dynamic-page/dynamic-page.component').then(m => m.DynamicPageComponent)
      }
    ]
  },
  {
    path: '**',
    redirectTo: ''
  }
];
